// activityMapping.ts

export const activityConfig: Record<
  string,
  { template: string; label: string }
> = {
  // --- Team Member ---
  "Member Added": {
    label: "Member Added",
    template: "{userName} was added to team {teamName}",
  },
  "Member Role Updated": {
    label: "Member Role Updated",
    template: "{member_name}'s role updated from {old_role} to {new_role}",
  },
  "Member Removed": {
    label: "Member Removed",
    template: "{userName} was removed from team {teamName}",
  },
  "Member Logged In": {
    label: "Member Logged In",
    template: "{member_name} logged in to team {team_name}",
  },
  "Member Fail to Log In": {
    label: "Member Fail to Log In",
    template: "{member_name} failed log in to team {team_name}",
  },
  "Member Logged Out": {
    label: "Member Logged Out",
    template: "{member_name} logged out from team {team_name}",
  },
  "Member Online Status Changed": {
    label: "Member Online Status Changed",
    template: "{member_name} is now {online_status} in team {team_name}",
  },
  "Team Name Changed": {
    label: "Team Name Changed",
    template: "Team name changed from {old_team_name} to {new_team_name}",
  },
  "Team Feature Added": {
    label: "Team Feature Added",
    template: "{feature_name} feature was added to team {team_name}",
  },
  "Team Feature Removed": {
    label: "Team Feature Removed",
    template: "{feature_name} feature was removed from team {team_name}",
  },
  "Member Enabled 2FA": {
    label: "Member Enabled 2FA",
    template: "enabled two-factor authentication",
  },
  "Member Disabled 2FA": {
    label: "Member Disabled 2FA",
    template: "disabled two-factor authentication",
  },
  "Member Password Reset": {
    label: "Member Password Reset",
    template: "password was reset",
  },
  "Member Profile Updated": {
    label: "Member Profile Updated",
    // template:
    //   "updated their profile parameter '{profile_parameter_name}', old value = '{oldName}', new value = '{newName}'",
    template:
      "updated their profile parameter from old value ='{oldEmail}'to new value = '{newEmail}'",
  },

  // --- WorkFlow ---
  "Status Added": {
    label: "Status Added",
    template: "New status '{status_name}' added to workflow '{workflow_name}'",
  },
  "Status Removed": {
    label: "Status Removed",
    template: "Status '{status_name}' removed from workflow '{workflow_name}'",
  },
  "Status Parameter Changed": {
    label: "Status Parameter Changed",
    template:
      "Parameters for status '{status_name}' updated parameter '{parameter_name}', old value = '{old_value}', new value = '{new_value}' in workflow '{workflow_name}'",
  },
  "Transition Added": {
    label: "Transition Added",
    template:
      "New transition '{transition_name}' added to status '{status_name}' in workflow '{workflow_name}'",
  },
  "Transition Updated": {
    label: "Transition Updated",
    template:
      "Transition '{transition_name}' in status '{status_name}' updated parameter '{parameter_name}', old value = '{old_value}', new value = '{new_value}'",
  },
  "Transition Removed": {
    label: "Transition Removed",
    template:
      "Transition '{transition_name}' removed from status '{status_name}' in workflow '{workflow_name}'",
  },
  "Transition Rule Added": {
    label: "Transition Rule Added",
    template:
      "New rule added to transition '{transition_name}' in status '{status_name}' of workflow '{workflow_name}'",
  },
  "Transition Rule Removed": {
    label: "Transition Rule Removed",
    template:
      "Rule removed from transition '{transition_name}' in status '{status_name}' of workflow '{workflow_name}'",
  },
  "Transition Rule Changed": {
    label: "Transition Rule Changed",
    template:
      "Rule for transition '{transition_name}' in status '{status_name}' updated parameter '{parameter_name}', old value = '{old_value}', new value = '{new_value}'",
  },
  "Workflow Created": {
    label: "Workflow Created",
    template: "New workflow '{workflow_name}' created",
  },
  "Workflow Set as Default": {
    label: "Workflow Set as Default",
    template: "Workflow '{workflow_name}' set as default",
  },

  // --- Project ---
  "Member Added to Project": {
    label: "Member Added to Project",
    template: "{member_name} was added to project {projectName}",
  },
  "Member Removed from Project": {
    label: "Member Removed from Project",
    template: "{member_name} was removed from project {projectName}",
  },
  "New Project Created": {
    label: "New Project Created",
    template: "New project '{projectName}' created",
  },
  "Project Name Updated": {
    label: "Project Name Updated",
    template:
      "Project name updated, old value = '{old_project_name}', new value = '{new_project_name}'",
  },
  "Project Status Updated": {
    label: "Project Status Updated",
    template:
      "Project '{projectName}' updated status, old value = '{oldStatus}', new value = '{newStatus}'",
  },

  // --- Ticket ---
  "Assignee Updated": {
    label: "Assignee Updated",
    template:
      "Ticket '{ticketName}' assignee changed from {old_assignee} to {new_assignee}",
  },
  "Ticket Created": {
    label: "Ticket Created",
    template: "New ticket '{ticketName}' created",
  },
  "Ticket Status Updated": {
    label: "Ticket Status Updated",
    template:
      "Ticket '{ticketName}' status changed from {oldStatusName} to {newStatusName}",
  },
  "Ticket Type Added": {
    label: "Ticket Type Added",
    template: "New ticket type '{typeName}' added",
  },
  "Ticket Type Updated": {
    label: "Ticket Type Updated",
    template: "Ticket type '{typeName}' was updated",
  },
  "Comment Added": {
    label: "Comment Added",
    template: "New comment added to ticket '{ticketName}'",
    // : \"{Preview}\"
  },
  "Comment Deleted": {
    label: "Comment Deleted",
    template: "Comment deleted from ticket '{ticketName}'",
  },
  "Comment Updated": {
    label: "Comment Updated",
    template:
      "Comment updated on ticket '{ticketName}'. New content: \"{updated_comment_preview}\"",
  },
  "Ticket Tag Added": {
    label: "Ticket Tag Added",
    // template: "Tag '{tag_name}' added to ticket '{ticketName}'",
    template: "Tag '{oldTagIds}' added to ticket '{newTagIds}'",
  },
  "Ticket Tag Removed": {
    label: "Ticket Tag Removed",
    template: "Tag '{tag_name}' removed from ticket '{ticketName}'",
  },
  "Tag Created": {
    label: "Tag Created",
    template: "New tag '{tagName}' created",
  },
  "Tag Updated": {
    label: "Tag Updated",
    template: "Tag '{tagName}' updated",
  },
  "Tag Removed": {
    label: "Tag Removed",
    template: "Tag '{tagName}' removed",
  },
  "Ticket Dependency Added": {
    label: "Dependency Updated",
    template:
      "Dependency added: Ticket '{ticketName}' now depends on '{dependent_ticket_name}'",
  },
  "Ticket Dependency Removed": {
    label: "Ticket Dependency Removed",
    template:
      "Dependency removed: Ticket '{ticketName}' no longer depends on '{dependent_ticket_name}'",
  },
  "Ticket Dependency Updated": {
    label: "Ticket Dependency Updated",
    template:
      "Dependency between '{ticketName}' and '{dependent_ticket_name}' was updated",
  },
  "Ticket Priority Updated": {
    label: "Ticket Priority Updated",
    template:
      "Ticket '{ticketName}' priority changed from {oldPriority} to {newPriority}",
  },
  "Ticket Due Date Updated": {
    label: "Ticket Due Date Updated",
    template:
      "Ticket '{ticketName}' due date changed from {oldDueDate} to {newDueDate}",
  },
  "Ticket Estimated Time Updated": {
    label: "Ticket Estimated Time Updated",
    template:
      "Ticket '{ticketName}' estimated time updated from {oldTime} to {newTime}",
  },
  "Ticket Description Updated": {
    label: "Ticket Description Updated",
    // template: "Ticket '{ticketName}' description updated",
    template:
      "Ticket description updated from {oldDescription} to {newDescription}",
  },
  "Ticket Linked": {
    label: "Ticket Linked",
    template: "Ticket '{ticketName}' linked to ticket '{linked_ticket_name}'",
  },
  "Ticket Unlinked": {
    label: "Ticket Unlinked",
    template:
      "Ticket '{ticketName}' unlinked from ticket '{unlinked_ticket_name}'",
  },
  "Attachment Uploaded": {
    label: "Attachment Uploaded",
    template: "New attachment '{newAttachments}' uploaded to ticket '{ticketName}'",
  },
  "Attachment Deleted": {
    label: "Attachment Deleted",
    template: "Attachment '{newAttachments}' deleted from ticket '{ticketName}'",
  },
  "Ticket Title Updated": {
    label: "Ticket Title Updated",
    template: "Ticket updated from {oldTitle} to {newTitle}",
  },
  // --- Releases ---
  "Release Created": {
    label: "Release Created",
    template: "New release '{release_name}' created",
  },
  "Release Approved": {
    label: "Release Approved",
    template: "Release '{release_name}' approved",
  },
  "Release Cancelled": {
    label: "Release Cancelled",
    template: "Release '{release_name}' cancelled",
  },
  "Release Completed": {
    label: "Release Completed",
    template: "Release '{release_name}' completed",
  },

  // --- Sprint ---
  "Sprint Status Updated": {
    label: "Sprint Status Updated",
    template: "Sprint '{sprintName}' status updated to {SprintStatus}",
  },
  "Sprint Created": {
    label: "Sprint Created",
    template: "New sprint '{sprintName}' created",
  },
  "Sprint Duration Modified": {
    label: "Sprint Duration Modified",
    template: "Sprint '{sprintName}' duration changed to {new_duration}",
  },

  // --- Time Tracking ---
  "Time Entry Added": {
    label: "Time Entry Added",
    template: "New time entry added for {ticket_or_project_name}",
  },
  "Day-Off Flagged": {
    label: "Day-Off Flagged",
    template: "flagged {date} as a day off",
  },

  // --- Boards ---
  "New Board Created": {
    label: "New Board Created",
    template: "New board '{boardName}' created",
  },
  "Column Added": {
    label: "Column Added",
    template: "New column '{column_name}' added to board '{boardName}'",
  },
  "Work in Progress (WIP) Limit Updated": {
    label: "Work in Progress (WIP) Limit Updated",
    template:
      "WIP limit updated to {new_limit} for column '{column_name}' on board '{boardName}'",
  },
  "Board Settings Saved": {
    label: "Board Settings Saved",
    template: "Board settings for '{boardName}' were updated",
  },

  // --- Import/Export ---
  "Tickets Exported": {
    label: "Tickets Exported",
    template: "{count} tickets exported ({size} MB)",
  },
  "Tickets Imported": {
    label: "Tickets Imported",
    template: "{count} tickets imported ({size} MB)",
  },
  "Users Imported": {
    label: "Users Imported",
    template: "{count} users imported ({size} MB)",
  },

  // --- QA Testing ---
  "Test Plan Created": {
    label: "Test Plan Created",
    template: "New test plan '{test_plan_name}' created",
  },
  "Test Plan Execution Completed": {
    label: "Test Plan Execution Completed",
    template:
      "Test plan '{test_plan_name}' execution completed: {pass_count} passed, {fail_count} failed",
  },

  // --- Archive ---

  "Ticket Assignee Updated": {
    label: "Ticket Assignee Updated",
    template:
      "Ticket '{ticketName}' assignee changed from {oldAssigneeName} to {newAssigneeName}",
  },
  "Archive Item": {
    label: "Archive Item",
    template: "{itemType} ' {itemName}' archived",
  },

  "Restore from archive": {
    label: "Restore from archive",
    template: "{itemType} ' {itemName}' restored from archive",
  },

  // Assignee
  "Assignee Added to Sprint": {
    label: "Assignee Added to Sprint",
    template: "Assignee '{assigneeName}' added to sprint '{sprintName}'",
  },

  // Notification
  "Notification Enabled": {
    label: "Notification Enabled",
    template: "Notification '{notificationName}' enabled",
  },

  "Notification Disabled": {
    label: "Notification Disabled",
    template: "Notification '{notificationName}' disabled",
  },

  // --- Notification Module New Additions ---
  "Ticket New Assignment": {
    label: "Ticket New Assignment",
    template: "Ticket '{ticketName}' reassigned to you by {assigner_name}.",
  },
  "Ticket Due Date Change": {
    label: "Ticket Due Date Change",
    template: "Due date for ticket '{ticketName}' changed to {new_due_date}.",
  },
  "Ticket Priority Change": {
    label: "Ticket Priority Change",
    template: "Priority for ticket '{ticket_name}' changed to {new_priority}.",
  },
  "Ticket Status Update": {
    label: "Ticket Status Update",
    template: "Status of ticket '{ticket_name}' updated to {new_status}.",
  },
  "Ticket Comment or Discussion": {
    label: "Ticket Comment or Discussion",
    template: "New comment on ticket '{ticket_name}' by {commenter_name}.",
  },
  "Ticket Attachment or File Upload": {
    label: "Ticket Attachment or File Upload",
    template:
      "New file '{file_name}' added to ticket '{ticket_name}' by {uploader_name}.",
  },
  "Ticket Overdue Alert For Assignee": {
    label: "Ticket Overdue Alert For Assignee",
    template:
      "Ticket '{ticket_name}' is overdue. Due date: {due_date}. Days overdue: {days_overdue}.",
  },
  "Ticket Overdue Alert For Project Manager": {
    label: "Ticket Overdue Alert For Project Manager",
    template:
      "Ticket '{ticket_name}' is overdue. Due date: {due_date}. Days overdue: {days_overdue}.",
  },
  "Approaching Due Date": {
    label: "Approaching Due Date",
    template: "Ticket '{ticket_name}' is due in 3 days.",
  },
  "Ticket User Mentioned": {
    label: "Ticket User Mentioned",
    template:
      "You were mentioned in ticket '{ticket_name}' by {mentioner_name}.",
  },
  "Ticket Attachment Updated": {
    label: "Ticket Attachment Updated",
    template:
      "File '{file_name}' updated in ticket '{ticket_name}' by {updater_name}.",
  },
  "Ticket Dependency Update": {
    label: "Ticket Dependency Update",
    template:
      "Dependency resolved: Ticket '{blocker_ticket_name}' completed. '{dependent_ticket_name}' can now proceed.",
  },
  "Ticket Blocked/Unblocked": {
    label: "Ticket Blocked/Unblocked",
    template:
      "Blocked: Ticket '{ticket_name}' has been blocked. Reason: {blocking_reason} Unblocked: Ticket '{ticket_name}' has been unblocked.",
  },
  "Ticket Estimation Changed": {
    label: "Ticket Estimation Changed",
    template:
      "Estimation for ticket '{ticketName}' changed from {oldValue} to {newValue}.",
  },
  "Release Date Approaching": {
    label: "Release Date Approaching",
    template:
      "Release {release_name} is approaching. Scheduled for {release_date}.",
  },
  "New Sprint Started": {
    label: "New Sprint Started",
    template: "New sprint {sprintName} has started.",
  },
  "Retrospective Received": {
    label: "Retrospective Received",
    template:
      "Retrospective for sprint {sprintName} has been received from {submitter_name}.",
  },
  "Sprint Retrospective Request": {
    label: "Sprint Retrospective Request",
    template: "Please submit your retrospective for sprint {sprintName}.",
  },
  "Team Invitation": {
    label: "Team Invitation",
    template: "You've been invited to join team {team_name}.",
  },
  "Member Role Changed": {
    label: "Member Role Changed",
    template: "Your role in team {team_name} has been updated to {new_role}.",
  },
  "Project Status Update": {
    label: "Project Status Update",
    template: "Project {project_name} status updated to {new_status}.",
  },
  "Day not reported": {
    label: "Day not reported",
    template: "Time not reported for {date}.",
  },
  "Time-off request approval": {
    label: "Time-off request approval",
    template:
      "{requester_name} has submitted a time-off request for {start_date} to {end_date}.",
  },
  "Time-off request approved / rejected": {
    label: "Time-off request approved / rejected",
    template:
      "Your time-off request for {start_date} to {end_date} has been {approved/rejected} by {manager_name}.",
  },
  "Transition Notification": {
    label: "Transition Notification",
    template: "Ticket {ticket_name} has transitioned to {new_status}.",
  },
  "Upcoming renewal": {
    label: "Upcoming renewal",
    template: "Your subscription for {team_name} will renew on {renewal_date}.",
  },
  "Successful payment": {
    label: "Successful payment",
    template: "Payment successful for {team_name} subscription.",
  },
  "Failed payment": {
    label: "Failed payment",
    template: "Payment failed for {team_name} subscription.",
  },
  "Plan changes": {
    label: "Plan changes",
    template: "Subscription plan changed for {team_name}.",
  },
  "Approaching Storage Limit": {
    label: "Approaching Storage Limit",
    template: "{team_name} is approaching storage limit.",
  },
  "Test Plan Assigned": {
    label: "Test Plan Assigned",
    template:
      "Test plan '{test_plan_name}' assigned to you by {assigner_name}.",
  },
  "Ticket Added to Sprint": {
    label: "Ticket Added to Sprint",
    template: "Ticket '{ticketName}' added to sprint '{sprintName}'.",
  },
  "Ticket Removed from Sprint": {
    label: "Ticket Removed from Sprint",
    template: "Ticket '{ticketName}' removed from sprint '{sprintName}'.",
  },
};
